import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import { isEmpty } from '@/utils/object';
import { mappingAttribute } from '@/views/shared/snippet-attribute.js';

const hasPreviousSearches = (state, commit, params) => {
	/*
    make the corrections to make it work with the filters(
	be sure send the correct params:
	params: {
		count: number,
		page: number,
		...
	})
	*/
	if (!isEmpty(state.previousSearches)) {
		const ps = state.previousSearches;
		const { search, count } = params;
		const keys = Object.keys(ps)
			.sort()
			.reverse();
		if (search) {
			const key = keys.find(k => search.includes(k));
			let objResults = ps[key] || {};
			if (key === search) {
				commit('setPreviousSearches', {
					[params.search]: objResults
				});
				return true;
			}
			if (key && count > objResults.totalCount) {
				objResults.items = objResults.items.filter(item => {
					return item.description
						.toLowerCase()
						.includes(search.toLowerCase());
				});

				commit('setPreviousSearches', {
					[params.search]: objResults
				});
				return true;
			}
		}
	}
	return false;
};

export default {
	name: 'autosuggest',
	namespaced: true,
	strict: process.env.NODE_ENV !== 'production',
	state: {
		previousSearches: {}
	},
	mutations: {
		setPreviousSearches(state, data) {
			state.previousSearches = Object.assign(
				{},
				state.previousSearches,
				data
			);
		}
	},
	actions: {
		async loadSnippets({ state, commit }, parameters) {
			if (!hasPreviousSearches(state, commit, parameters)) {
				let results = await api.get(
					buildRoute('/snippets', parameters)
				);

				results.items.forEach(element => {
					element.description = element.description
						? element.description
						: '';

					element.snippetAttributeDisplay =
						mappingAttribute[element.snippetAttribute];
				});

				commit('setPreviousSearches', { [parameters.search]: results });
			}
		}
	},
	getters: {
		getPreviousSearchesByKey: state => key => {
			const result = state.previousSearches[key];
			return result || {};
		}
	}
};
